import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "../../../components/Header/Header";
import IndentDetails from "../IndentPage/ItemsPage/IndentDetails";
import SHItemsTable from "./SHItemsTable";
import { useSelector } from "react-redux";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const SHInvoicingPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { row } = location.state || {};

  const [error, setError] = useState(null);
  const currentUserId = useSelector((state) => state.auth.id);

  // Force Close Indent Handler
  const handleForceCloseIndent = async () => {
    if (!row?.IndentID) {
      setError("No indent selected");
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/shpage/indents/forceClose`, {
        indentId: row.IndentID,
        userId: currentUserId
      });

      navigate('/SHPage', { 
        state: { 
          message: "Indent force closed successfully" 
        } 
      });
    } catch (error) {
      console.error("Force Close Error:", error);
      setError(
        error.response?.data?.error || 
        "Failed to force close indent"
      );
    }
  };

  return (
    <div>
      <Header />
      <div className="container mx-auto p-6">
        <div className="mt-6 mb-2 text-center">
          <h3 className="text-xl font-semibold">Store Head Approval</h3>
        </div>
        
        {row && (
          <>
            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                {error}
              </div>
            )}
            
            <IndentDetails row={row} userId={currentUserId} />
            
            <SHItemsTable 
              indentID={row.IndentID}
              userId={currentUserId}
              onForceClose={handleForceCloseIndent}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SHInvoicingPage;